import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AOS from "aos";
import "aos/dist/aos.css";

// Layouts
import VerticalLayout from "../Layout/VerticalLayout";

// Auth
import { AuthProtected } from "./AuthProtected";

// Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// Layout type selector
import { layoutTypes } from "../constants/layout";
import { createSelector } from "reselect";

const getLayout = (layoutType) => {

    switch (layoutType) {
        case layoutTypes.VERTICAL:
            return VerticalLayout;
        default:
            return VerticalLayout;
    }
};

const Index = () => {
    const routeSelector = createSelector(
        (state) => state.Layout,
        (state) => ({ layoutType: state.layoutType })
    );

    const { layoutType } = useSelector(routeSelector);
    const Layout = getLayout(layoutType);

    // Scroll to top on route change
    const location = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        AOS.refresh();
        AOS.init({
            duration: 1000,
            once: false,
            offset: window.innerHeight * 0.01 
        });
    }, [location.pathname]);

    return (
        <Routes>
            {/* Public Routes */}
            {publicRoutes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    element={
                            <Layout>{route.component}</Layout>
                    }
                />
            ))}

            {/* Protected Routes - Only this block should exist */}
            {authProtectedRoutes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    element={
                        <AuthProtected>
                            <Layout>{route.component}</Layout>
                        </AuthProtected>
                    }
                />
            ))}
        </Routes>
    );
};

export default Index;
